// Mirrors the [Flags] EThumbsDownReason of the AI assistant processor and the ES conversation document (PBI 11213).
// Several reasons combine with bitwise OR; the numbers are stored, never renumber them.
const EThumbsDownReason = Object.freeze({
    None: 0,
    WrongSubsidy: 1,
    OutdatedInformation: 2,
    TooGeneric: 4,
    MisunderstoodMe: 8,
    SomethingElse: 16
});

export default EThumbsDownReason;
